// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PArrowsAltOutlinedSvg from "@fishx/icons-svg/es/asn/PArrowsAltOutlined";
import FishxIcon from '../components/FishxIcon';

var PArrowsAltOutlined = function PArrowsAltOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PArrowsAltOutlinedSvg
  }));
};

PArrowsAltOutlined.displayName = 'PArrowsAltOutlined';
export default React.forwardRef(PArrowsAltOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PArrowsAltOutlined.js
// module id = 3222
// module chunks = 0